import { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import GImage from 'components/common/gImage'
import { SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper'
import { LinkButton } from 'components/common/typography'
import SelectionArrows from 'components/common/selectionArrows'
import { Section, PaddingContainer, ConditionalDiv, AutoSwiper } from 'components/common/common_styles'
import { MainTitle, ButtonContainer, ArrowContainer, PaginationContainer } from './homeScenes_styles'

const HomeScenes = () => {
  const { prismicHomePage: { data } } = useStaticQuery(query)
  const [swiper, setSwiper] = useState()

  return (
    <Section washi>
      <PaddingContainer padBottom={6}>
        <MainTitle>{data.scene_title}</MainTitle>
        <AutoSwiper
          slidesPerView='auto'
          spaceBetween={16}
          centeredSlides={true}
          loop={true}
          pagination={{
            el: '.pagination-container'
          }}
          modules={[Pagination]}
          onSwiper={_swiper => {
            setSwiper(_swiper)
            // This prevents a blank space on init where an image should be. It won't work without the setTimeout
            setTimeout(() => {
              _swiper.slideTo(3, 0, false)
            }, 10)
          }}
        >
          {data.scene_images.map(image =>
            <SwiperSlide key={image.image.alt}>
              <GImage data={image.image} />
            </SwiperSlide>
          )}
          <PaginationContainer className='pagination-container' />
        </AutoSwiper>
        <ButtonContainer>
          <ConditionalDiv desktopOnly>
            <div />
          </ConditionalDiv>
          <LinkButton link={data.scene_button_link}>{data.scene_button_title}</LinkButton>
          <ConditionalDiv desktopOnly>
            <ArrowContainer>
              <SelectionArrows clickLeft={() => swiper?.slidePrev()} clickRight={() => swiper?.slideNext()} />
            </ArrowContainer>
          </ConditionalDiv>
        </ButtonContainer>
      </PaddingContainer>
    </Section>
  )
}

export default HomeScenes

export const query = graphql`
  query {
    prismicHomePage {
      data {
        scene_title
        scene_button_title
        scene_button_link
        scene_images {
          image {
            alt
            gatsbyImageData
          }
        }
      }
    }
  }
`
